/** 创建项目模块初始状态。 */
const initialCreateProjectState = {
    isDialogOpen: false,
    editingProject: null,
    sessionKey: null,
};
/** 打开创建项目弹窗（创建模式）。 */
export function openCreateProjectDialog(sessionKey) {
    return { type: 'createProject/openDialog', ...(sessionKey ? { sessionKey } : {}) };
}
/** 打开编辑项目弹窗，携带编辑目标。 */
export function openEditProjectDialog(project) {
    return { type: 'createProject/openEditDialog', project };
}
/** 关闭创建/编辑项目弹窗并清空编辑目标。 */
export function closeCreateProjectDialog(resetSession = false) {
    return { type: 'createProject/closeDialog', resetSession };
}
/** 根据动作生成新的创建项目状态，保持状态转换集中且可测试。 */
export function createProjectReducer(state = initialCreateProjectState, action) {
    switch (action.type) {
        case 'createProject/openDialog':
            return {
                ...state,
                isDialogOpen: true,
                editingProject: null,
                sessionKey: action.sessionKey ?? state.sessionKey,
            };
        case 'createProject/openEditDialog':
            return { ...state, isDialogOpen: true, editingProject: action.project, sessionKey: null };
        case 'createProject/closeDialog':
            return {
                ...state,
                isDialogOpen: false,
                editingProject: null,
                sessionKey: action.resetSession ? null : state.sessionKey,
            };
        case 'session/logoutSucceeded':
        case 'session/sessionExpired':
            return initialCreateProjectState;
        default:
            return state;
    }
}
